<template>
  <div class="dropoff-points">
    <div class="dropoff-points__title" v-if="pickupPoint.title">
      {{ pickupPoint.title }}
    </div>

    <div class="dropoff-points__subtitle">{{ pickupPoint.subtitle }}</div>
    <div
      class="has-more-dropoff"
      :class="{ hover: tooltipModalVisible }"
      v-if="hasMoreDropoffLabel"
      v-on:mouseover="showTooltipModal"
      v-on:mouseleave="hideTooltipModal"
    >
      <span>{{ hasMoreDropoffLabel }}</span>

      <div
        class="tooltip-modal custom-scrollbar"
        :style="tooltipModalStyle"
        v-if="tooltipModalVisible"
        v-on:mouseover="onOverTooltipModal"
        v-on:mouseleave="onLeaveTooltipModal"
      >
        <OrderPath
          class="order-path-list-view"
          :order="order"
          :expand="true"
          :orderPathHeader="true"
        />
      </div>
    </div>
    <div class="dropoff-points__title last-point" v-if="lastDropoffPoint.title">
      {{ lastDropoffPoint.title }}
    </div>

    <div class="dropoff-points__subtitle">{{ lastDropoffPoint.subtitle }}</div>
  </div>
</template>

<script>
const { debounce } = require('@/plugins/lodash')
const OrderPath = () => import('@/components/record_detail_v2/OrderPath.vue')

export default {
  name: 'DropoffPoints',
  components: {
    OrderPath
  },
  props: {
    points: {
      required: true
    },
    order: {
      required: true
    }
  },
  data() {
    return {
      pickupPoint: {
        title: '',
        subtitle: ''
      },
      lastDropoffPoint: {
        title: '',
        subtitle: ''
      },
      hasMoreDropoffLabel: '',

      tooltipModalVisible: false,
      tooltipModalStyle: {},
      mouseoverTooltipModal: false
    }
  },
  beforeMount() {
    const length = this.points.length

    this.pickupPoint = this.getPoint(this.points[0])

    if (length > 1) {
      this.lastDropoffPoint = this.getPoint(this.points[length - 1])
    }

    if (length > 2) {
      this.hasMoreDropoffLabel = this.$t('records.list.more_dropoff', { num: length - 2 })
    }
  },
  methods: {
    getPoint(point = {}) {
      const { name, mobile, address } = point
      const dot = name && mobile ? ' • ' : ''
      const result = {}

      result.title = name ? `${name}` : ''
      result.title += mobile ? `${dot}${mobile}` : ''
      result.subtitle = address

      return result
    },
    showTooltipModal($event) {
      if (this.tooltipModalVisible) return

      const innerHeight = $event.view && $event.view.innerHeight
      const left = $event.x + 70
      let top = $event.y - 150
      if (innerHeight > 0) {
        const outOfScreenY = top + 320 - innerHeight
        top -= outOfScreenY > 0 ? outOfScreenY : 0
      }

      this.tooltipModalStyle = {
        left: `${left}px`,
        top: `${top}px`
      }
      this.tooltipModalVisible = true
    },
    hideTooltipModal: debounce(function () {
      if (!this.mouseoverTooltipModal) {
        this.tooltipModalVisible = false
      }
    }, 300),
    onOverTooltipModal() {
      this.mouseoverTooltipModal = true
    },
    onLeaveTooltipModal() {
      this.mouseoverTooltipModal = false
      this.hideTooltipModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.dropoff-points {
  .dropoff-points__title {
    color: #1a1a1a;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    &.last-point {
      margin-top: 8px;
    }
  }

  .dropoff-points__subtitle {
    color: #7a8189;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;
  }

  .has-more-dropoff {
    font-size: 14px;
    line-height: 20px;
    color: #7a8189;
    margin-top: 8px;
    position: relative;

    &.hover {
      span {
        color: #ff8200;
      }
    }

    span {
      &:hover {
        color: #ff8200;
      }
    }

    .tooltip-modal {
      position: fixed;
      z-index: 1;
      width: 445px;
      height: 310px;
      overflow-y: auto;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      border-radius: 8px;
    }
  }
}
</style>
